import { Radio, RadioGroup } from "@nju/form";
import { IScope } from "@nju/scope";
import { Separator } from "@nju/ui";
import { Text } from "@nju/ui";
import { ISelectedPostpaidDay } from "./PostpaidMigration.machine";

interface IPostpaidMigrationFormProps {
  variant?: IScope;
  handlePostpaidDateSelect(value: ISelectedPostpaidDay): void;
}

export function PostpaidMigrationForm({
  variant,
  handlePostpaidDateSelect,
}: IPostpaidMigrationFormProps) {
  return (
    <form>
      <RadioGroup
        aria-label="msisdn offer type"
        name="msisdn-offer-type"
        onValueChange={(value) => {
          handlePostpaidDateSelect(value as ISelectedPostpaidDay);
        }}
      >
        <Radio space="narrow" value="EOP">
          z końcem obecnej umowy
        </Radio>
        <div className="ml-6 mt-[-15px]">
          <Text className="whitespace-pre-line">
            {variant !== "sales" &&
              "Przeniesiemy Twój numer w dniu wyznaczonym przez Twojego obecnego operatora, \n bez opłat za wcześniejsze zakończenie umowy."}
            {variant === "sales" &&
              "Przeniesiemy numer klienta w dniu wyznaczonym przez jego obecnego operatora, \n bez opłat za wcześniejsze zakończenie umowy."}
          </Text>
        </div>
        <Separator size="xs" tone="invisible" />
        <Radio space="narrow" value="DAY">
          {variant !== "sales" ? "chcę wybrać datę" : "klient chce wybrać datę"}
        </Radio>
        <div className="ml-6 mt-[-15px]">
          <Text>
            {variant !== "sales" &&
              "Wybierz dzień, który będzie dla Ciebie najlepszy. Może to się wiązać z dodatkowymi kosztami."}
            {variant === "sales" &&
              "Klient wybiera dzień, który będzie dla niego najlepszy. Może się to wiązać z dodatkowymi kosztami."}
          </Text>
        </div>
        <Separator size="xs" tone="invisible" />
      </RadioGroup>
    </form>
  );
}
